import React from "react";
import {
  Building2,
  Search,
  FileText,
  UserCheck,
  Rocket,
  CreditCard,
} from "lucide-react";

function HowWorks() {
  const steps = [
    {
      no: "01",
      icon: Building2,
      title: "Choose Your Branch",
      desc: "Select your Polytechnic branch and area of interest & industry demands.",
    },
    {
      no: "02",
      icon: Search,
      title: "Explore Programs",
      desc: "Browse available internship programs, technologies and online offline mode.",
    },
    {
      no: "03",
      icon: FileText,
      title: "Apply Online",
      desc: "Complete the internship application form with your details.",
    },
    {
      no: "04",
      icon: CreditCard,
      title: "Pay Fees",
      desc: "Securely pay internship fees through online payment methods.",
    },
    {
      no: "05",
      icon: UserCheck,
      title: "Get Approved",
      desc: "Our team reviews your application and confirms enrollment.",
    },
    {
      no: "06",
      icon: Rocket,
      title: "Start Internship",
      desc: "Begin training, work on live projects and earn certification.",
    },
  ];

  return (
    <section className="py-16 px-6 lg:px-16 bg-white dark:bg-[#050505]">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/20 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/20 blur-[140px] rounded-full"></div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]"></div>

      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            How It Works
          </h2>

          <div className="w-20 h-1 bg-primary mx-auto mt-3 rounded-full"></div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8 relative">
          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <div key={index} className="relative text-center group">
                {/* Line */}
                {index !== steps.length - 1 && (
                  <div className="hidden md:block absolute top-10 left-[65%] w-full border-t-2 border-dashed border-primary/30 z-0"></div>
                )}

                {/* Step Number */}
                <div className="relative z-10 mx-auto mb-4 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white text-xs font-bold shadow-lg">
                  {step.no}
                </div>

                {/* Icon */}
                <div className="relative z-10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full border border-primary/20 bg-primary/5 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                  <Icon className="w-8 h-8" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  {step.title}
                </h3>

                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HowWorks;
